module.exports = __webpack_public_path__ + "img/26_29.2f24a16f.png";